"use client"

import { useState, useEffect } from "react"
import { useSession } from "next-auth/react"

const CHANNEL_NAME = "pediloo:notifications"

export function useChatUnreadCount() {
  const { data: session } = useSession()
  const [chatUnreadCount, setChatUnreadCount] = useState(0)

  useEffect(() => {
    if (!session?.user?.id) return
    let cancelled = false

    fetch("/api/notifications")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data) setChatUnreadCount(data.chatUnreadCount ?? 0)
      })
      .catch(() => {})

    let channel: BroadcastChannel | null = null
    try {
      channel = new BroadcastChannel(CHANNEL_NAME)
      channel.onmessage = (e: MessageEvent) => {
        if (e.data?.type === "notifications-update") {
          setChatUnreadCount(e.data.chatUnreadCount ?? 0)
        }
      }
    } catch {}

    return () => {
      cancelled = true
      channel?.close()
    }
  }, [session?.user?.id])

  return chatUnreadCount
}